export function flatten(arr) {
    return arr.reduce(function(flat, toFlatten) {
        if (Array.isArray(toFlatten)) {
            toFlatten = flatten(toFlatten);
        }
        return flat.concat(toFlatten);
    }, []);
}

export function dedup(arr) {
    return arr.filter(function(value, i, full) {
        var sliced = full.slice(0, i);
        return sliced.indexOf(value) === -1;
    });
}
